import { createFileRoute } from '@tanstack/react-router';
import {
  loadProductRulesMessages,
  loadProductRulesScreens,
  productRulesListScreen,
  productRulesSearch,
} from '@/modules/credit-product-rules/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/cadastro/configuracao-regras/')({
  validateSearch: productRulesSearch,
  staticData: { screen: productRulesListScreen },
  loader: () => loadProductRulesMessages(),
  component: lazyScreen(loadProductRulesScreens, 'ProductRulesListScreen'),
});
